import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the "Shift Details" step of the NEW Shift Request form is viewed
 * Event: dental_portal:shift_request:shift_details_viewed
 */
export function fireShiftDetailsPageViewed(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:shift_details_viewed', {
    'Design Date': 202603,
  });
}
